import React from "react";
import shortid from "shortid";

import useConstants from "@hooks/useConstants";
import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const { BRAND_NAME } = process.env;

const ProFAQ = () => {
	const classes = useStyles("Pro");
	const { sections } = useConstants("ProFAQViewModel");

	return (
		<>
			<section className={classes.hiwWrapper}>
				<Container maxWidth={false} style={{ maxWidth: 800 }}>
					<Paper variant={"outlined"}>
						<Box
							display={"flex"}
							alignItems={"center"}
							justifyContent={"center"}
							p={{ xs: 8, sm: "72px 40px" }}
						>
							<Box maxWidth={640}>
								<Box mb={11}>
									<Box
										component="h2"
										fontSize={{ xs: 26, sm: 32 }}
										fontWeight={600}
										lineHeight={1.2}
										mt={0}
										mb={0}
									>
										Your questions answered
									</Box>
									<Box color={"grey.700"} mt={2} lineHeight={1.5}>
										{`Answers to commonly asked questions about ${BRAND_NAME}.`}
									</Box>
								</Box>

								{sections.map((section, index) => (
									<Accordion
										key={shortid.generate()}
										classes={{ root: classes.accordionRoot }}
									>
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls={`FAQ-${index}`}
											id={`FAQ-${index}`}
											classes={{
												root: classes.accordionSRoot,
												content: classes.accordionSContent,
											}}
										>
											<h3 className={classes.faqQuestion}>
												{section.question}
											</h3>
										</AccordionSummary>
										<AccordionDetails
											classes={{ root: classes.accordionDetailsRoot }}
										>
											<div className={classes.faqAnswer}>
												<div
													dangerouslySetInnerHTML={{
														__html: section.answer,
													}}
												/>
											</div>
										</AccordionDetails>
									</Accordion>
								))}
							</Box>
						</Box>
					</Paper>
				</Container>
			</section>
			{/* <Box
				component="section"
				className={classes.hiwWrapper}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"center"}
			>
				<Container maxWidth={false} className={classes.proContainer}>
					<h2 className={classes.joinH2}>Your questions answered</h2>
					<Grid container spacing={2}>
						{sections.map((section, index) => (
							<React.Fragment key={`FAQ-${index}`}>
								<Grid item xs={12}>
									<Box mb={4}>
										<Box component={"h3"} className={classes.joinH3}>
											{section.question}
										</Box>
										<Box className={classes.joinBodyText}>
											<div
												dangerouslySetInnerHTML={{ __html: section.answer }}
											/>
										</Box>
									</Box>
								</Grid>
							</React.Fragment>
						))}
					</Grid>
				</Container>
			</Box> */}
		</>
	);
};

export default ProFAQ;
